import React from 'react'
import BadgeUI from '../../../widgets/output/BadgeUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import './OrderItemLeft.css'

const OrderItemLeftUI = ({context, messageList, item}) =>
  <div className='ord_item_l'>
    {
      item.maker &&
      <div className='g_small'>
        {item.maker}
      </div>
    }
    <div>
      {item.name}
    </div>
    <div className='g_m_top_50'>
      {
        item.status === 'open' &&
        <LabelAndValueUI messageList={messageList} labelKey='c_due_date'>
          <div className='g_small'>{item.dueDateF1}</div>
        </LabelAndValueUI>
      }
      {
        item.status === 'done' &&
        <LabelAndValueUI messageList={messageList} labelKey='c_completion_date'>
          <div className='g_small g_flex_h date_badge'>
            {item.doneDateF1}
            <div className='g_m_left_100'>
              <BadgeUI messageList={messageList} labelKey='c_status_done' />
            </div>
          </div>
        </LabelAndValueUI>
      }
    </div>
  </div>

export default OrderItemLeftUI
